import SmartAccountLoader from './SmartAccountLoader';

export default function LoadingSpinner({ 
  message, 
  size = 'medium', 
  className = '' 
}: { 
  message?: string; 
  size?: 'sm' | 'md' | 'lg' | 'small' | 'medium' | 'large';
  className?: string;
}) {
  let mappedSize: 'small' | 'medium' | 'large' = 'medium';
  if (size === 'sm' || size === 'small') mappedSize = 'small';
  else if (size === 'lg' || size === 'large') mappedSize = 'large';

  return (
    <div className={className}>
      <SmartAccountLoader message={message} size={mappedSize} />
    </div>
  );
}





